export const ITEMS_PER_PAGE = 30

export const DEFAULT_SORT = {
  order: 'ASC',
  by: 'status',
} as const

export const ONE_HOUR_MS = 60000

export const CURRENCY_FRACTION_DIGITS = 2
